import React from 'react';
import {
  Redirect, Route, Switch,
} from 'react-router-dom';
import App from './App';
import config from '../config/config';

const LocaleRoutes = () => {
  const browserLocale = (window.navigator.userLanguage || window.navigator.language).slice(0, 2) === 'fr' ? 'fr' : 'en';

  return (
    <Switch>
      {(config.LOCALES.map(((item) => (
        <Route
          path={`/${item}`}
          key={item}
          render={(routeProps) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <App {...routeProps} item={item} />
          )}
        />
      ))))}

      <Route render={({ location }) => (
        <Redirect to={`/${browserLocale}${location.pathname}${location.hash}`} />)}
      />
    </Switch>
  );
};

LocaleRoutes.propTypes = {
  // disableForceChangeLocale: PropTypes.func,
};

export default LocaleRoutes;
